import React, { useEffect, useState } from 'react';
import { Flex, Text, Button } from 'rebass';
import styled from 'styled-components';
import { withRouter } from 'react-router-dom';
import { compose, withApollo } from 'react-apollo';

import withSession from '../lib/withSession';
import gql from 'graphql-tag';
import PleaseWait from '../components/PleaseWait';
import { GET_MEMBERSHIP_HANDOFF_URL } from '../graphql';

const Wrapper = styled(Flex)`
  padding-left: 60px;
  padding-top: 40px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 32px;
  @media screen and (max-width: 480px) {
    padding-left: 0;
  }
`;

export const GET_RX_TOKEN = gql`
  mutation getRxToken {
    getRxToken
  }
`;

const MySubscriptionRefund = ({ session, match, history, client }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    getToken();
  }, []);

  const getToken = async () => {
    const f = match.params.id;

    if(!f){
      setIsLoading(false);
      setIsError(true);
    }

    const createSession = await client.mutate({
      mutation: GET_MEMBERSHIP_HANDOFF_URL,
      variables:{
        subscriptionId: f,
        flow: 'refund'
      }
    });
    if (createSession && createSession.data && createSession.data.membershipHandoffUrl) {
      window.location = createSession.data.membershipHandoffUrl;
    } else {
      setIsLoading(false);
      setIsError(true);
    }
  };

  if (isLoading) {
    return (
      <Wrapper>
        <PleaseWait />
      </Wrapper>
    );
  }

  if (isError) {
    return (
      <Wrapper>
        <Text>An error occured</Text>
        <Button onClick={() => history.replace('/my-subscriptions')} variant={'primary'}>
          Your Subscriptions
        </Button>
      </Wrapper>
    );
  }

  return <div />;
};

export default compose(
  withSession,
  withRouter,
  withApollo,
)(MySubscriptionRefund);
